<template>
    <div class="package-search-button hidden-mobile block text-center sm:text-left flex flex-col">
        <a href="#" @click.prevent="toggle()" class="package-search-link text-sm rounded bg-white text-brand hover:bg-brand hover:text-white px-4 py-2 font-medium" v-if="!show">
            <i class="fas fa-search" aria-hidden="true"></i>
        </a>
        <input v-else type="text" ref="searchbox" v-model="query" class="text-sm rounded-sm p-1 mb-0 focus:ring-brand" v-on-clickaway="toggle"/>
    </div>
</template>

<script>
    import {mixin as clickaway} from 'vue-clickaway';

    export default {
        mixins: [clickaway],
        data: function () {
            return {
                show: false,
                query: ''
            };
        },
        computed: {},
        watch: {
            query: function () {
                eventBus.$emit('package-search-query-changed', this.query);
            }
        },
        methods: {
            toggle: function () {
                let that = this;
                this.show = !this.show;

                if (!this.show) {
                    this.query = '';
                }else{
                    this.$nextTick(() => {
                        that.$refs.searchbox.focus();
                    });
                }
            }
        },
        mounted() {
        }
    }
</script>
